import { openapi } from '@scalar/openapi-parser';
import { Hono } from 'hono';
import { cors } from 'hono/cors';
import { getOperations } from './utils/getOperations.js';
import { handleAuthentication } from './utils/handleAuthentication.js';
import { honoRouteFromPath } from './utils/honoRouteFromPath.js';
import { isAuthenticationRequired } from './utils/isAuthenticationRequired.js';
import { logAuthenticationInstructions } from './utils/logAuthenticationInstructions.js';
import { setupAuthenticationRoutes } from './utils/setupAuthenticationRoutes.js';
import { mockAnyResponse } from './routes/mockAnyResponse.js';
import { respondWithOpenApiDocument } from './routes/respondWithOpenApiDocument.js';

/**
 * Create a mock server instance
 */
async function createMockServer(options) {
    const app = new Hono();
    /** Dereferenced OpenAPI document */
    const { schema } = await openapi()
        .load(options?.specification ?? {})
        .dereference()
        .get();
    // CORS headers
    app.use(cors());
    /** Authentication methods defined in the OpenAPI document */
    setupAuthenticationRoutes(app, schema);
    logAuthenticationInstructions(schema?.components?.securitySchemes || {});
    /** Paths specified in the OpenAPI document */
    const paths = schema?.paths ?? {};
    Object.keys(paths).forEach((path) => {
        const methods = Object.keys(getOperations(paths[path]));
        /** Keys for all operations of a specified path */
        methods.forEach((method) => {
            const route = honoRouteFromPath(path);
            const operation = schema?.paths?.[path]?.[method];
            // Check if authentication is required for this operation
            if (isAuthenticationRequired(operation.security)) {
                app[method](route, handleAuthentication(schema, operation));
            }
            // Actual route
            app[method](route, (c) => mockAnyResponse(c, operation, options));
        });
    });
    // OpenAPI JSON file
    app.get('/openapi.json', (c) => respondWithOpenApiDocument(c, options?.specification, 'json'));
    // OpenAPI YAML file
    app.get('/openapi.yaml', (c) => respondWithOpenApiDocument(c, options?.specification, 'yaml'));
    return app;
}

export { createMockServer };
